import * as React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import type { SxProps } from "@mui/material/styles";

import { misc } from "app/themes/colors";

import { classes } from "../appointment-preview.component";

type PreviewContentRowProps = {
  Icon?: React.ElementType;
  content: React.ReactNode;
  testId?: string;
  highlighted?: boolean;
  containerSx?: SxProps;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;

  sx?: SxProps;
};
export default function PreviewContentRow({
  Icon,
  content,
  testId,
  highlighted,
  onMouseEnter,
  onMouseLeave,
  sx,
  containerSx
}: PreviewContentRowProps) {
  return (
    <Grid
      container
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        background: highlighted ? misc.mutedPurple : undefined,
        mb: 0.25,
        borderRadius: "4px",
        paddingTop: highlighted ? 1.5 : 0,
        paddingBottom: highlighted ? 1 : 0,
        ...containerSx
      }}
    >
      <Grid item xs={2} className={classes.textCenter}>
        {Icon && <Icon className={classes.grayIcon} />}
      </Grid>
      <Grid item xs={10}>
        <Box
          component="div"
          data-testid={testId}
          className={classes.text}
          sx={sx}
        >
          {content}
        </Box>
      </Grid>
    </Grid>
  );
}
